<!--
 * @Description: 教育行业
 * @Author: pliybird
 * @Date: 2023-05-25 14:11:17
 * @LastEditTime: 2023-06-20 13:56:43
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @filePath: Do not edit
-->
<template>
  <Layout>
    <!-- banner -->
    <div>
      <div class="slider-area slider-style-2 variation-3 height-720 bg_image bg_image_fixed" :style="{
        'background-image': `url(${require(`@/assets/images/IndustrySolution/banner/industry-banner-02.png`)})`,
      }">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="inner text-center">
                <h2 class="title" data-aos="fade-up" data-aos-delay="100">
                  {{ $t("solution.education.header.title01") }}
                </h2>
                <h4 class="subtitle color-white mb--30" data-aos="fade-up" data-aos-delay="200">
                  {{ $t("solution.education.header.title02") }}
                </h4>
                <p class="col-12 offset-lg-3 col-lg-6 description color-white" data-aos="fade-up" data-aos-delay="300">
                  {{ $t("solution.education.header.description") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-section-gapBottom industry-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <div class="row row--0 align-items-center mt_dec--30 wrapper">
                <div class="col-lg-12 mt_sm--30 mb_sm--30">
                  <div class="content row align-items-center">
                    <div class="col-12 col-lg-2 col-md-2 text-center">
                      <img class="icon" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-icon1.png')
                        " alt="" />
                    </div>
                    <div class="inner col-12 col-lg-10 col-md-10">
                      <h4 class="title mb--10">
                        {{ $t("solution.education.header.card.title01") }}
                      </h4>
                      <p class="description mb--10">
                        {{ $t("solution.education.header.card.title02") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.education.header.card.description01") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.education.header.card.description02") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.education.header.card.description03") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.education.header.card.description04") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <section class="rn-section-gap">
      <SectionTitle :title="$t('solution.solutions_title')" description="SOLUTIONS" textAlign="center" />
      <div class="container">
        <EducationSolution />
      </div>
    </section>
    <div class="">
      <!-- 客户价值 -->
      <custom-value customState="center" pageLayout="centerFour" :list="list"></custom-value>
    </div>
    <!-- 方案优势 -->
    <section class="rn-section-gap edu-advantage">
      <div class="container">
        <SectionTitle :title="$t('solution.advantages_title')" description="ADVANTAGES" textAlign="center" />
        <EducationAdvantage />
      </div>
    </section>
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>
  
<script>
import Layout from "@/components/common/Layout";
import CustomValue from "./components/CustomValue.vue";
import ClassicCases from "./components/ClassicCases.vue";
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
import EducationAdvantage from "./EducationAdvantage.vue";

import EducationSolution from "./components/EducationComponents/EducationSolution.vue";
export default {
  name: "Education",
  components: {
    Layout,
    CustomValue,
    ClassicCases,
    EducationSolution,
    EducationAdvantage,
    SectionTitle
  },
  props: {},
  data() {
    return {
      list: [
        { title: this.$t('solution.education.values.tab.tab01') },
        { title: this.$t('solution.education.values.tab.tab02') },
        { title: this.$t('solution.education.values.tab.tab03') },
        { title: this.$t('solution.education.values.tab.tab04') },
      ],
      //产品案例
      ClassicCasesData: [
        {
          // imageBackground: require("@/assets/images/IndustrySolution/ClassicCases/WEILINGTON_background.png"),
          brandIcon: require("@/assets/images/IndustrySolution/ClassicCases/WEILINGTON_icon.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>